'use strict';

goog.provide("Ntry.aiBlock");

goog.require("Ntry.block");

Blockly.Blocks['ai_start'] = {
    init: function() {
        this.setColour("#3BBD70");
        this.appendDummyInput()
                .appendField(new Blockly.FieldIcon('/legacy_img/assets/block_icon/start_icon_play.png', '*', "start"))
                .appendField(Lang.Menus.maze_when_run);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_start = function (sprite, script) {
    return script.callReturn();
};

Blockly.Blocks['ai_move_right'] = {
    init: function() {
    this.setColour("#A751E3");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_forward)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/moveStep.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_right = function (entity, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        Ntry.dispatchEvent("gridChange", function() {
            script.isAction = false;
        });
        var spaceShipComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SPACE_SHIP
        );
        spaceShipComp.direction = Ntry.STATIC.EAST;
        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );
        Ntry.entityManager.addComponent(
            entity.id, {
                 type: Ntry.STATIC.ANIMATE,
                 animateType: Ntry.STATIC.ROTATE_TO,
                 animateValue: 0
            }
        );
        gridComp.x++;
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['ai_move_up'] = {
    init: function() {
    this.setColour("#A751E3");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_above)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/ai_move_up.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_up = function (entity, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        Ntry.dispatchEvent("gridChange", function() {
            script.isAction = false;
        });
        var spaceShipComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SPACE_SHIP
        );
        spaceShipComp.direction = Ntry.STATIC.NORTH;
        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );
        Ntry.entityManager.addComponent(
            entity.id, {
                 type: Ntry.STATIC.ANIMATE,
                 animateType: Ntry.STATIC.ROTATE_TO,
                 animateValue: -45
            }
        );
        gridComp.x++;
        gridComp.y--;
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['ai_move_down'] = {
    init: function() {
    this.setColour("#A751E3");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_under)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/ai_move_down.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_down = function (entity, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        Ntry.dispatchEvent("gridChange", function() {
            script.isAction = false;
        });
        var spaceShipComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SPACE_SHIP
        );
        spaceShipComp.direction = Ntry.STATIC.SOUTH;
        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );
        Ntry.entityManager.addComponent(
            entity.id, {
                 type: Ntry.STATIC.ANIMATE,
                 animateType: Ntry.STATIC.ROTATE_TO,
                 animateValue: 45
            }
        );
        gridComp.x++;
        gridComp.y++;
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['ai_repeat_until_reach'] = {
    init: function() {
        this.setColour("#498DEB");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_repeat_until_dest)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', "endOrigin"));
        this.appendStatementInput("STACK");
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_repeat_until_reach = function (entity, script) {
    return script.getStatement("STACK", script);
};

Blockly.Blocks['ai_if_else_1'] = {
    init: function() {
        this.setColour("#498DEB");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_front_1);
        this.appendDummyInput()
            .appendField(new Blockly.FieldImage("/legacy_img/assets/ntry/bitmap/ai/obstacle_1.png", 22, 22, "meteo"));
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_front_2)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', "endOrigin"));
        this.appendStatementInput("STACK_IF");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_else);
        this.appendStatementInput("STACK_ELSE");
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_if_else_1 = function (entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var radar = Ntry.entityManager.getComponent(
        entity.id, Ntry.STATIC.RADAR
    );
    script.isLooped = true;
    if (radar.center.type == Ntry.STATIC.AI_METEO &&
        radar.center.distance == 1)
        return script.getStatement("STACK_IF", script);
    else
        return script.getStatement("STACK_ELSE", script);
};


Blockly.Blocks['ai_if_else_2'] = {
    init: function() {
        this.setColour("#498DEB");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_1);
        this.appendValueInput("BOOL")
            .setCheck("Boolean");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_2)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', "endOrigin"));
        this.appendStatementInput("STACK_IF");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_else);
        this.appendStatementInput("STACK_ELSE");
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_if_else_2 = function (sprite, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var value = script.getBooleanValue("BOOL", script);
    script.isLooped = true;
    if (value)
        return script.getStatement("STACK_IF", script);
    else
        return script.getStatement("STACK_ELSE", script);
};

Blockly.Blocks['ai_boolean_distance'] = {
    init: function() {
        this.setColour("#2fc9f0");
        this.appendDummyInput()
            .appendField(' ', "#3D3D3D")
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.ai_above, "UP"],
                [Lang.Menus.ai_front, "RIGHT"],
                [Lang.Menus.ai_under, "DOWN"]
                ]), "DIRECTION");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_radar, "#ffffff");
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([
                [">","BIGGER"],
                [">=","BIGGER_EQUAL"],
                ["=","EQUAL"],
                ["<","SMALLER"],
                ["<=","SMALLER_EQUAL"]
                ]), "OPERATOR");
        this.appendValueInput("DATA")
            .setCheck(["Number", "String"]);
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_distance = function (entity, script) {
    var radar = Ntry.entityManager.getComponent(
        entity.id, Ntry.STATIC.RADAR
    );

    var direction = script.getField("DIRECTION");
    var operator = script.getField("OPERATOR");
    var value = script.getValue("DATA");

    var radarValue;
    switch (direction) {
        case "UP":
            radarValue = radar.left;
            break;
        case "RIGHT":
            radarValue = radar.center;
            break;
        case "DOWN":
            radarValue = radar.right;
            break;
    }
    if (radarValue.type == Ntry.STATIC.AI_GOAL)
        radarValue = Number.MAX_VALUE;
    else
        radarValue = radarValue.distance;

    switch (operator) {
        case "BIGGER":
            return radarValue > value;
        case "BIGGER_EQUAL":
            return radarValue >= value;
        case "EQUAL":
            return radarValue == value;
        case "SMALLER":
            return radarValue < value;
        case "SMALLER_EQUAL":
            return radarValue <= value;
    }
};

Blockly.Blocks['ai_distance_value'] = {
  init: function() {
    this.setColour("#ffd974");
    this.appendDummyInput()
        .appendField(new Blockly.FieldDropdown([
            [Lang.Menus.ai_above, "UP"],
            [Lang.Menus.ai_front, "RIGHT"],
            [Lang.Menus.ai_under, "DOWN"]
          ]), "DIRECTION");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_radar, '#000000');
    this.setOutput(true, 'Number');
    this.setInputsInline(true);
  }
};

Ntry.block.ai_distance_value = function (entity, script) {
    var radar = Ntry.entityManager.getComponent(
        entity.id, Ntry.STATIC.RADAR
    );

    var direction = script.getField("DIRECTION");
    var operator = script.getField("OPERATOR");
    var value = script.getField("VALUE");

    var radarValue;
    switch (direction) {
        case "UP":
            radarValue = radar.left;
            break;
        case "RIGHT":
            radarValue = radar.center;
            break;
        case "DOWN":
            radarValue = radar.right;
            break;
    }
    if (radarValue.type == Ntry.STATIC.AI_GOAL)
        radarValue = Number.MAX_VALUE;
    else
        radarValue = radarValue.distance;
    return radarValue;
}

Blockly.Blocks['ai_boolean_object'] = {
    init: function() {
        this.setColour("#2FC9F0");
        this.appendDummyInput()
            .appendField(' ', "#3D3D3D")
            .appendField(Lang.Menus.ai_object_is_1, "#ffffff")
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.ai_above, "UP"],
                [Lang.Menus.ai_front, "RIGHT"],
                [Lang.Menus.ai_under, "DOWN"]
                ]), "DIRECTION");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_object_is_2, "#ffffff");
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.asteroids, "OBSTACLE"],
                [Lang.Menus.wall, "WALL"],
                [Lang.Menus.item, "ITEM"]
                ]), "OBJECT");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_object_is_3, "#ffffff");
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_object = function (entity, script) {
    var radar = Ntry.entityManager.getComponent(
        entity.id, Ntry.STATIC.RADAR
    );

    var direction = script.getField("DIRECTION");
    var obstacle = script.getField("OBJECT");
    var value = script.getField("VALUE");

    var radarValue;
    switch (direction) {
        case "UP":
            radarValue = radar.left;
            break;
        case "RIGHT":
            radarValue = radar.center;
            break;
        case "DOWN":
            radarValue = radar.right;
            break;
    }
    radarValue = radarValue.type;
    switch (obstacle) {
        case "OBSTACLE":
            return radarValue == Ntry.STATIC.AI_METEO;
        case "WALL":
            return radarValue == Ntry.STATIC.AI_WALL;
        case "ITEM":
            return radarValue == Ntry.STATIC.AI_ITEM;
    }
};


Blockly.Blocks['ai_use_item'] = {
  init: function() {
    this.setColour("#EACF11");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_use_item)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/item.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setNextStatement(true);
    this.setPreviousStatement(true);
    this.setTooltip('');
  }
};

Ntry.block.ai_use_item = function (entity, script) {
    if (!script.isStart) {
        Ntry.dispatchEvent("triggerWeapon");
        script.isStart = true;
        script.isAction = true;
        Ntry.dispatchEvent("gridChange", function() {
            script.isAction = false;
        });
        var spaceShipComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SPACE_SHIP
        );
        spaceShipComp.direction = Ntry.STATIC.EAST;
        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );
        Ntry.entityManager.addComponent(
            entity.id, {
                 type: Ntry.STATIC.ANIMATE,
                 animateType: Ntry.STATIC.ROTATE_TO,
                 animateValue: 0
            }
        );
        gridComp.x++;
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['ai_boolean_and'] = {
    init: function() {
        this.setColour("#2fc9f0");
        this.appendValueInput("LEFTHAND")
            .setCheck("Boolean");
        this.appendDummyInput()
            .appendField(Lang.Blocks.JUDGEMENT_boolean_and, "#ffffff");
        this.appendValueInput("RIGHTHAND")
            .setCheck("Boolean");
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_and = function (sprite, script) {
    var leftValue = script.getBooleanValue("LEFTHAND", script);
    var rightValue = script.getBooleanValue("RIGHTHAND", script);
    return leftValue && rightValue;
};








var unColor = '#E5E5E5';

/* block_un */
Blockly.Blocks['ai_start_un'] = {
    init: function() {
        this.setColour('#78dda6');
        this.appendDummyInput()
                .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/start_un.png', '*', "start"))
                .appendField(Lang.Menus.maze_when_run);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_start_un = Ntry.block.ai_start;

Blockly.Blocks['ai_move_right_un'] = {
    init: function() {
    this.setColour('#cc9df9');
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_forward)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/move_right_un.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_right_un = Ntry.block.ai_move_right

Blockly.Blocks['ai_move_up_un'] = {
    init: function() {
    this.setColour('#cc9df9');
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_above)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/ai_move_up_un.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_up_un = Ntry.block.ai_move_up

Blockly.Blocks['ai_move_down_un'] = {
    init: function() {
    this.setColour('#cc9df9');
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_move_under)
        .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/ai_move_down_un.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip('');
    }
};

Ntry.block.ai_move_down_un = Ntry.block.ai_move_down;

Blockly.Blocks['ai_repeat_until_reach_un'] = {
    init: function() {
        this.setColour("#abcdf4");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_repeat_until_dest)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/repeat_un.png', '*', "endOrigin"));
        this.appendStatementInput("STACK");
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_repeat_until_reach_un = Ntry.block.ai_repeat_until_reach;

Blockly.Blocks['ai_if_else_1_un'] = {
    init: function() {
        this.setColour("#abcdf4");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_front_1);
        this.appendDummyInput()
            .appendField(new Blockly.FieldImage("/legacy_img/assets/ntry/bitmap/ai/obstacle_1.png", 22, 22, "meteo"));
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_front_2)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if_un.png', '*', "endOrigin"));
        this.appendStatementInput("STACK_IF");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_else);
        this.appendStatementInput("STACK_ELSE");
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_if_else_1_un = Ntry.block.ai_if_else_1;

Blockly.Blocks['ai_if_else_2_un'] = {
    init: function() {
        this.setColour("#abcdf4");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_1);
        this.appendValueInput("BOOL")
            .setCheck("Boolean");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_if_2)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if_un.png', '*', "endOrigin"));
        this.appendStatementInput("STACK_IF");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_else);
        this.appendStatementInput("STACK_ELSE");
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_if_else_2_un = Ntry.block.ai_if_else_2;

Blockly.Blocks['ai_boolean_distance_un'] = {
    init: function() {
        this.setColour("#78edf9");
        this.appendDummyInput()
            .appendField(' ', "#3D3D3D")
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.ai_above, "UP"],
                [Lang.Menus.ai_front, "RIGHT"],
                [Lang.Menus.ai_under, "DOWN"]
                ]), "DIRECTION");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_radar, "#000000");
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([
                [">","BIGGER"],
                [">=","BIGGER_EQUAL"],
                ["=","EQUAL"],
                ["<","SMALLER"],
                ["<=","SMALLER_EQUAL"]
                ]), "OPERATOR");
        this.appendValueInput("DATA")
            .setCheck(["Number", "String"]);
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_distance_un = Ntry.block.ai_boolean_distance;

Blockly.Blocks['ai_distance_value_un'] = {
  init: function() {
    this.setColour("#ffedc5");
    this.appendDummyInput()
        .appendField(new Blockly.FieldDropdown([
            [Lang.Menus.ai_above, "UP"],
            [Lang.Menus.ai_front, "RIGHT"],
            [Lang.Menus.ai_under, "DOWN"]
          ]), "DIRECTION");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_radar, '#000000');
    this.setOutput(true, 'Number');
    this.setInputsInline(true);
  }
};

Ntry.block.ai_distance_value_un = Ntry.block.ai_distance_value;

Blockly.Blocks['ai_boolean_object_un'] = {
    init: function() {
        this.setColour("#78edf9");
        this.appendDummyInput()
            .appendField(' ', "#3D3D3D")
            .appendField(Lang.Menus.ai_object_is_1, "#ffffff")
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.ai_above, "UP"],
                [Lang.Menus.ai_front, "RIGHT"],
                [Lang.Menus.ai_under, "DOWN"]
                ]), "DIRECTION");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_object_is_2, "#ffffff")
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([
                [Lang.Menus.asteroids, "OBSTACLE"],
                [Lang.Menus.wall, "WALL"],
                [Lang.Menus.item, "ITEM"]
                ]), "OBJECT");
        this.appendDummyInput()
            .appendField(Lang.Menus.ai_object_is_3, "#ffffff")
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_object_un = Ntry.block.ai_boolean_object;


Blockly.Blocks['ai_use_item_un'] = {
  init: function() {
    this.setColour("#f4e690");
    this.appendDummyInput()
        .appendField(Lang.Menus.ai_use_item)
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/item_un.png', '*', "endOrigin"));
    this.setInputsInline(true);
    this.setNextStatement(true);
    this.setPreviousStatement(true);
    this.setTooltip('');
  }
};

Ntry.block.ai_use_item_un = Ntry.block.ai_use_item;

Blockly.Blocks['ai_boolean_and_un'] = {
    init: function() {
        this.setColour("#78edf9");
        this.appendValueInput("LEFTHAND")
            .setCheck("Boolean");
        this.appendDummyInput()
            .appendField(Lang.Blocks.JUDGEMENT_boolean_and, "#ffffff");
        this.appendValueInput("RIGHTHAND")
            .setCheck("Boolean");
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    }
};

Ntry.block.ai_boolean_and_un = Ntry.block.ai_boolean_and;
